import React from 'react';

interface IErrorCrossIconProps {
	size?: string;
	className?: string;
}

export const ErrorCrossIcon = ({ size = '24', className = '' }: IErrorCrossIconProps) => (
	<svg
		role="img"
		className={className}
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		aria-labelledby="errorCrossIcon">
		<title id="errorCrossIcon">error cross icon</title>
		<path
			d="M2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C6.8043 20.9464 9.34784 22 12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12C22 9.34783 20.9464 6.8043 19.0711 4.92893C17.1957 3.05357 14.6522 2 12 2C9.34784 2 6.8043 3.05357 4.92893 4.92893C3.05357 6.8043 2 9.34783 2 12Z"
			fill="#DD3131"
		/>
		<path d="M8 8L16 16" stroke="white" strokeWidth="2" strokeLinejoin="round" />
		<path d="M16 8L8 16" stroke="white" strokeWidth="2" strokeLinejoin="round" />
	</svg>
);
